import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authRducer from "./auth";
 import localizationReducer from "./Localization";
import themeReducer from "./DarkMode"
import ordersReducer from "./Orders"
import searchReducer from './Search'
import usersReducer from "./Users"
import BannersReducer from "./Banners"
import productsReducer from "./Products"
import categoriesReducer from "./categories"
import citiesRducer from "./cities";

const persistConfig = {
	key: "root",
	version: 1,
	storage,
};

const RootReducers = combineReducers({

	auth: authRducer,
theme: themeReducer,
currentLocal: localizationReducer,
orders:ordersReducer,
search:searchReducer,
users:usersReducer,
banners:BannersReducer,
products:productsReducer,
categories:categoriesReducer,
    cities: citiesRducer,

// profile:profileReducer,
});

const persistedReducer = persistReducer(persistConfig, RootReducers);

export default configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});